export const SEND_EMAIL_MUTATION = gql`
  mutation sendEmail($input: EmailInput!) {
    sendEmail(input: $input)
  }
`;

/**
 * The To/CC pickers' recipients: one bounded, searched page of contacts (optionally one business
 * entity's) and one of the organization's members (P7-R35). Replaces `findRecipients`' `take: 5000` reads.
 */
export const RECIPIENT_PICKER_QUERY = gql`
  query RecipientPickerQuery(
    $businessEntityId: Int
    $contactInput: StandardPageInput
    $membershipInput: StandardPageInput
  ) {
    contactPage(businessEntityId: $businessEntityId, input: $contactInput) {
      edges {
        node {
          id
          knockId
          name
          email
          businessEntity {
            id
            name
          }
        }
      }
    }
    membershipPage(input: $membershipInput) {
      edges {
        node {
          id
          user {
            id
            knockId
            email
            firstName
            lastName
          }
        }
      }
    }
  }
`;
